import { FC } from 'react'
import Divider from '../divider/Divider'
import './Section.scss'

type Props = {
  title: string | React.ReactNode,
  description?: string,
  children: React.ReactNode
}
const Section: FC<Props> = ({ title, description = '', children }: Props) => {
  return (
    <div className="section">
      <div className="section__heading">
        <span className="section__title">{title}</span>
        <span className="section__description">{description}</span>

        <Divider className="divider" />
      </div>
      {children}
    </div>
  )
}

export default Section
